import { render, staticRenderFns } from "./ManualSearch.vue?vue&type=template&id=afdaf320&scoped=true&"
import script from "./ManualSearch.vue?vue&type=script&setup=true&lang=js&"
export * from "./ManualSearch.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afdaf320",
  null
  
)

export default component.exports